import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

export const Dropdown = ({
  label,
  options,
  value,
  onChange,
  className,
  innerClassName,
}: {
  label?: string
  options: { value?: string; label: ReactNode }[]
  value?: string
  onChange?: (value: any) => void
  className?: string
  innerClassName?: string
}) => {
  return (
    <div className={twMerge("flex flex-col gap-1 relative shrink-0", className)}>
      {label && (
        <label className="type-label-l" htmlFor={label}>
          {label}
        </label>
      )}
      <div className="w-full relative">
        <select
          value={value}
          onChange={(e) => {
            // onChange?.(e.target.value)
            onChange?.(e)
          }}
          className={twMerge(
            "block !w-full !max-w-none !border !border-current placeholder:text-current/20 rounded-sm !h-button px-3 type-label-m !mr-7 md:!mr-6 !appearance-none !bg-none bg-transparent",
            innerClassName,
          )}
        >
          {options.map((option, ox) => (
            <option key={`${option.value}${ox}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute right-2 mt-[0.2em] top-1/2 -translate-y-1/2 w-[1.4em] h-[1.4em] pointer-events-none">
          <span className="type-label-m transform rotate-90 flex items-center justify-center">→</span>
        </div>
      </div>
    </div>
  )
}
